import(/* webpackMode: "eager" */ "E:\\VQBits_Windows\\LeadProp\\LeadProp\\leadprop-frontend\\src\\app\\page.tsx");
